import React, { useState, useRef, forwardRef, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { BarLoader } from "react-spinners";
import "../css/AddProject.css";
import Select from "react-select";
import { pink } from "@mui/material/colors";
import Switch from "@mui/material/Switch";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import PDF from "../image/PDF.png";
import ID_CARD from "../image/ID_CARD.png";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";

import XLSX_ICON from "../image/XLS.png";
import {
  Box,
  Button,
  Divider,
  Modal,
  Tooltip,
  Typography,
  Drawer,
  MenuItem,
  InputLabel,
  FormControl,
  TablePagination,
  Collapse,
  Paper,
  Grid,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  IoIosClose,
  IoMdClose,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { use } from "react";
import { FaEye, FaEyeSlash, FaIdCard } from "react-icons/fa";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      style={{ padding: "6px" }}
      onValueChange={(values) => {
        if (Number(values.value) < 0) return;
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      allowNegative={false}
      prefix="$"
    />
  );
});

const iframeStyle = {
  width: "100%",
  height: "-webkit-fill-available",
  border: "none", // Remove iframe border if needed
};

function AddUser() {
  const navigate = useNavigate();
  const userdata = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    if (projectNameInputRef) {
      projectNameInputRef?.current?.focus();
    }
  }, []);

  const [users, setUsers] = useState([]);
  const [userView, setUserView] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedRole, setSelectedRole] = useState("contractor");
  const [showAll, setShowAll] = React.useState(false);
  const [invalidFiles, setInvalidFiles] = useState([]);
  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: "asc",
  });
  const [expandedRowId, setExpandedRowId] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [roleFilter, setRoleFilter] = React.useState("Contractor");

  const [previewModaTitle, setPreviewModaTitle] = useState("");
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);

  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };
  useEffect(() => {
    getUsers();
  }, []);

  const allColumns = [
    { field: "user_name", headerName: "User Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 2 },
    { field: "role", headerName: "Role", flex: 1 },
    { field: "contact_info", headerName: "Phone", flex: 1 },
  ];
  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };
  // const getUsers = async () => {
  //   try {
  //     const response = await axios.get("/cvault/get-users/");
  //     const data = response?.data?.data || [];

  //     setUsers(data);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //     toast.error("Failed to fetch users. Please try again later.");
  //   }
  // };


  const viewFiles = async (file, iframeShow = false, title) => {
    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);
      setViewReport(true);
      let formattedTitle;

      if (title === "IRS_Form_W9") {
        setModalTitle("IRS Form W-9");
      } else if (title === "photo_id") {
        setModalTitle("Photo ID");
      } else {
        formattedTitle = title
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        setModalTitle(formattedTitle);
      }

      setFileError("");

      const downloadFile = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();

        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };

      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data); // For displaying inline preview
          } else {
            setViewReport(false);

            downloadFile(response); // For unsupported file types, download the file
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            // setContractDocuments(true);
            // setSelectedContractDoc(response.data.base64_content); // Set the file to preview
          } else {
            setViewReport(false);

            downloadFile(response); // Download unsupported files
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        setLoader(false);
        setIsLoader(false);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        toast.error(
          error?.response?.data?.error || "File not found in cloud storage"
        );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "70%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  // Filtered data
  const filteredUsers = useMemo(() => {
    if (!Array.isArray(users)) return [];

    return users.filter((user) => {
      const matchesSearch =
        user?.email?.toLowerCase().includes(search.toLowerCase()) ||
        user?.user_name?.toLowerCase().includes(search.toLowerCase()) ||
        user?.role?.toLowerCase().includes(search.toLowerCase()) ||
        user?.contact_info?.toLowerCase().includes(search.toLowerCase());

      const matchesRole = selectedRole
        ? user?.role?.toLowerCase() === selectedRole.toLowerCase()
        : true;

      return matchesSearch && matchesRole;
    });
  }, [users, search, selectedRole]);

  const projectNameInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [AImessage, setAImessage] = useState(false);
  const [pdfmilestone, setPdfmilestone] = useState([]);
  const [projectUniqueError, setProjectUniqueError] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [projectFiles, setProjectFiles] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [zipError, setZipError] = useState("");
  const [yearError, setYearError] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const currentYear = new Date().getFullYear();
  const startYear = 1900;
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year.toString());
  }

  const [isLoader, setIsLoader] = React.useState(false);
  const [showDocuments, setShowDocuments] = React.useState(false);
  const [viewReport, setViewReport] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState("");

  const [fileError, setFileError] = React.useState("");
  const controllerRef = React.useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [emailErrors, setEmailErrors] = useState("");
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1);
  const [issubmitting, setissubmitting] = useState(false);

  const steps = ["Personal Details", "Company & Bank Details"];
  const [routingNumError, setRoutingNumError] = useState("");
  const [accountNumError, setAccountNumError] = useState("");
  const [phoneNumError, setPhoneNumError] = useState("");

  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const [tableLoader, setTableLoader] = React.useState(false);

  const firstNameRef = useRef(null);

  const [formData, setFormData] = useState({
    email: "",
    role: "owner",
    username: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    stateName: "",
    zip: "",
    companyName: "",
    yearFounded: "",
    employees: "",
    contractorLicense: "",
    accountHolder: "",
    bankName: "",
    routingNumber: "",
    accountNumber: "",
    coOwnerName: "",
    password: "",
    // formationDoc: null,
    photoID: null,
    // EINLetter: null,
    // IRSForm: null,
    confirmPassword: "",
    // KYCBeneficial: null,
    CopyOfID: null,
    designation: "Commercial Building Inspector",
    AdditionalDocuments: null,
  });

  const borderStyle = (field) =>
    emptyFields[field] ? { border: "1px solid red" } : { borderRadius: "6px" };
  const iframeStyleContractDocs = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const [state, setState] = useState({
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    user_name: "",
    role: "inspector",
    company_name: "",
    cmp_found_year: "",
    no_of_employes: "",
    acnum: "",
    bankname: "",
    accountname: "",
    co_owner: "",
    designation: "",
  });


  
  console.log(tableLoader,";;;;;;;;;;;;;;;;;;;;");
  

  const getUsers = async () => {
    setTableLoader(true);

    try {
      const response = await axios.get("/cvault/get-users/");
      let data = response?.data?.data ?? [];

      // 🧩 Step 1: Map and reorder fields logically
      data = data.map((user) => {
        const {
          role,
          contact_info,
          cmp_found_year,
          company_name,
          acc_number,
          acc_holder_name,
          no_of_employes,
          kyc_ownership_certificate,
          irs_form,
          ein_confirmation_letter,
          photo_id,
          additional_document,
          formation_document,
          banking_detail,
          date_joined,
          ...rest
        } = user;

        return {
          // 👤 Personal Details (first)
          id: user.id ?? "",
          name: user.user_name || user.name || "",
          email: user.email ?? "",
          phone: contact_info ?? user.phone ?? "",
          role: role ?? "",
          date_joined: date_joined
            ? `${String(new Date(date_joined).getMonth() + 1).padStart(
                2,
                "0"
              )}-${String(new Date(date_joined).getDate()).padStart(
                2,
                "0"
              )}-${new Date(date_joined).getFullYear()}`
            : "",
          photo_id: photo_id ?? "",
          address: user.address ?? "",
          city: user.city ?? "",
          state: user.state ?? "",
          zip_code: user.zip_code ?? "",
          co_owner_name: user.co_owner_name ?? "",
          // designation: user.designation ?? "",

          // 🏢 Company Details (second)
          company_Name: company_name ?? "",
          company_Founded_Year: cmp_found_year ?? "",
          no_of_employees: no_of_employes ?? "",
          formation_document: formation_document ?? "",
          KYC_Beneficial_Ownership_Certificate: kyc_ownership_certificate ?? "",
          EIN_Confirmation_Letter: ein_confirmation_letter ?? "",
          IRS_Form_W9: irs_form ?? "",
          Contractor_License_Information: user.certificates ?? null,
          additional_documents: additional_document ?? [],

          // 🏦 Bank Details (last)
          bank_name: user.bank_name ?? "",
          account_Holder_Name: acc_holder_name ?? "",
          account_Number: acc_number ?? "",
          routing_number: user.routing_number ?? "",
          banking_detail: banking_detail ?? {},

          // Keep rest if needed
          // ...rest,
        };
      });

      // 🧹 Step 2: Role-based filtering (remove unwanted keys per role)
      const filteredData = data.map((user) => {
        const { last_login, is_active, id, role, ...rest } = user;
        let filteredUser = { id, role, ...rest };

        if (role === "Owner") {
          const {
            company_Founded_Year,
            company_Name,
            Contractor_License_Information,
            banking_detail,
            no_of_employees,
            formation_document,
            KYC_Beneficial_Ownership_Certificate,
            EIN_Confirmation_Letter,
            IRS_Form_W9,
            ...restOwner
          } = filteredUser;
          filteredUser = restOwner;
        } else if (role === "Inspector") {
          const {
            company_Founded_Year,
            company_Name,
            co_owner_name,
            no_of_employees,
            Contractor_License_Information,
            banking_detail,
            account_Holder_Name,
            bank_name,
            account_Number,
            IRS_Form_W9,
            KYC_Beneficial_Ownership_Certificate,
            EIN_Confirmation_Letter,
            photo_id,
            routing_number,
            formation_document,
            address,
            zip_code,
            state,
            city,
            additional_documents,
            ...restInspector
          } = filteredUser;
          filteredUser = restInspector;
        } else if (role === "Contractor") {
          const {
            co_owner_name,
            banking_detail,
            formation_document,
            KYC_Beneficial_Ownership_Certificate,
            EIN_Confirmation_Letter,
            IRS_Form_W9,
            ...restContractor
          } = filteredUser;
          filteredUser = restContractor;
        }

        return filteredUser;
      });

      // 🧭 Step 3: Normalize for table display
      const normalized = filteredData.map((u) => ({
        ...u,
        _display: {
          id: u.id,
          name: u.name || "N/A",
          email: u.email || "N/A",
          role: u.role || "N/A",
          phone: u.phone || "N/A",
          date: u.date_joined
            ? (() => {
                const d = new Date(u.date_joined);
                const mm = String(d.getMonth() + 1).padStart(2, "0");
                const dd = String(d.getDate()).padStart(2, "0");
                const yyyy = d.getFullYear();
                return `${mm}-${dd}-${yyyy}`;
              })()
            : "N/A",
        },
      }));

      setRows(normalized);
      setTableLoader(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Error fetching users");
      setTableLoader(false);
    }
  };
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  const headers = {
    "X-CSRFToken": cookies.csrftoken,
    "Content-Type": "multipart/form-data",
  };
  const [errorMsg, setErrorMsg] = useState("");

  const validatePassword = (password) => {
    if (!password) return false; // empty = not valid
    // accepts any non-alphanumeric as special character
    const strongPasswordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    return strongPasswordRegex.test(password);
  };
  const validateStep = () => {
    let required = [];

    if (step === 1) {
      required = [
        "firstName",
        "lastName",
        "email",
        "phone",
        "address",
        "city",
        "stateName",
        "zip",
        // "password",
        // "confirmPassword",
        "companyName",
        "yearFounded",
        "employees",
        "contractorLicense",
        "accountHolder",
        "bankName",
        "routingNumber",
        "accountNumber",
        // "formationDoc",
        "photoID",
        // "EINLetter",
        // "IRSForm",
        "AdditionalDocuments",
      ];
    }

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    if (step === 2 && formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return false;
    }

    return true;
  };

  const validateOwnerStep = () => {
    let required = [];

    required = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "address",
      "city",
      "stateName",
      "zip",
      // "password",
      // "confirmPassword",
      "accountHolder",
      "bankName",
      "routingNumber",
      "accountNumber",
      // "KYCBeneficial",
      "CopyOfID",
      // "IRSForm",
      "coOwnerName",
      "AdditionalDocuments",
    ];

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    return true;
  };
  const clearSingleFile = (name, index) => {
    setFormData((prev) => {
      const updatedFiles = prev[name].filter((_, i) => i !== index);
      return {
        ...prev,
        [name]: updatedFiles.length > 0 ? updatedFiles : null, // ✅ set to null when empty
      };
    });

    // Optional: clear error if applicable
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset input value (if all cleared)
    const input = document.getElementById(name);
    if (input) input.value = "";
  };
  const validateInspectorStep = () => {
    const required = ["firstName", "lastName", "email", "phone", "designation"];
    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    return true;
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (name === "role") {
      setFormData({
        email: "",
        role: value,
        username: "",
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
        city: "",
        stateName: "",
        zip: "",
        companyName: "",
        yearFounded: "",
        employees: "",
        contractorLicense: "",
        accountHolder: "",
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        coOwnerName: "",
        password: "",
        // formationDoc: null,
        photoID: null,
        // EINLetter: null,
        // IRSForm: null,
        confirmPassword: "",
        // KYCBeneficial: null,
        CopyOfID: null,
        designation: "Commercial Building Inspector",
        AdditionalDocuments: null,
      });
    }

    // --- FILE UPLOAD HANDLING ---
    if (type === "file") {
      e.preventDefault();
      const input = e.target; // get input reference
      const files = input.files;

      if (!files || files.length === 0) {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
        setFormData((prev) => ({
          ...prev,
          [name]: name === "photoID" ? null : [],
        }));
        input.value = ""; // reset input value so same file can trigger again
        return;
      }

      const maxSize = maxSizes[name];
      const allowed = allowedTypes[name];
      const fileArray = Array.from(files);

      const existingFiles = Array.isArray(formData[name])
        ? formData[name]
        : formData[name]
        ? [formData[name]]
        : [];

      // ✅ Restrict total number of files to 10
      const totalFilesCount = existingFiles.length + fileArray.length;
      if (totalFilesCount > 10) {
        toast.warning("You cannot upload more than 10 files.");
        input.value = ""; // reset input
        return;
      }

      // ✅ Check for duplicate file names
      const duplicateFile = fileArray.find((newFile) =>
        existingFiles.some((existing) => existing.name === newFile.name)
      );

      if (duplicateFile) {
        toast.warning(`File "${duplicateFile.name}" already uploaded.`);
        input.value = ""; // reset input so same-file selection triggers again
        return;
      }

      // ✅ Validate file type and size
      const invalidFiles = fileArray.filter(
        (file) => !allowed.includes(file.type) || file.size > maxSize
      );

      if (invalidFiles.length > 0) {
        const invalid = invalidFiles[0];
        if (!allowed.includes(invalid.type)) {
          setErrors((prev) => ({
            ...prev,
            [name]: `Invalid file type. Allowed: ${allowed
              .map((t) => t.split("/")[1]?.toUpperCase() || t)
              .join(", ")}.`,
          }));
        } else if (invalid.size > maxSize) {
          const mb = maxSize / (1024 * 1024);
          setErrors((prev) => ({
            ...prev,
            [name]: `File "${invalid.name}" exceeds ${mb}MB limit.`,
          }));
        }
        setEmptyFields((prev) => ({ ...prev, [name]: true }));
        input.value = ""; // reset input again
        return;
      }

      // ✅ Clear errors and set files
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setEmptyFields((prev) => ({ ...prev, [name]: false }));
      setFormData((prev) => ({
        ...prev,
        [name]:
          name === "photoID"
            ? fileArray[0]
            : [...(prev[name] || []), ...fileArray],
      }));

      input.value = ""; // ✅ Always reset at the end
      return;
    }

    // --- NON-FILE INPUT HANDLING ---
    if (name === "email") setEmailErrors("");
    if (name === "routingNumber") setRoutingNumError("");
    if (name === "accountNumber") setAccountNumError("");
    if (name === "zip") setZipError("");
    if (name === "phone") setPhoneNumError("");

    setFormData((prev) => {
      const trimmedValue = [
        "password",
        "confirmPassword",
        "phone",
        "zip",
      ].includes(name)
        ? value
        : typeof value === "string"
        ? value.trimStart()
        : value;

      const updated = { ...prev, [name]: trimmedValue };

      // --- Auto-generate username ---
      if (name === "firstName" || name === "lastName") {
        updated.username = `${updated.firstName} ${updated.lastName}`.trim();
      }

      if (name === "role") updated.role = value;

      // --- Phone formatting ---
      if (name === "phone") {
        const formatted = formatPhoneNumber(value);
        updated.phone = formatted;
      }

      // --- Year validation ---
      if (name === "yearFounded") {
        const isValidYear = validateYear(value);
        setEmptyFields((prev) => ({ ...prev, yearFounded: !isValidYear }));
      }

      // --- ZIP validation ---
      if (name === "zip") {
        let digitsOnly = value.replace(/\D/g, "");
        if (digitsOnly.length > 5) digitsOnly = digitsOnly.slice(0, 5);
        updated.zip = digitsOnly;

        const isValidZip = digitsOnly.length === 5;
        setEmptyFields((prev) => ({ ...prev, zip: !isValidZip }));
      }

      // --- Date validation ---
      if (name === "dayOfBirth") {
        const isValidDate = validateDate(value);
        setEmptyFields((prev) => ({ ...prev, dayOfBirth: !isValidDate }));
      }

      // --- Password validation ---
      if (name === "password" || name === "confirmPassword") {
        const password = updated.password;
        const confirmPassword = updated.confirmPassword;
        const passwordValid = validatePassword(password);
        const passwordsMatch = password === confirmPassword;
        const passwordEmpty = !password;
        const confirmEmpty = !confirmPassword;

        setPasswordError("");

        if (passwordEmpty && confirmEmpty) {
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        } else if (!passwordValid && !passwordEmpty) {
          setPasswordError(
            "Password must be at least 8 characters long and contain at least one letter, one number, and one special character."
          );
          setEmptyFields((prev) => ({
            ...prev,
            password: true,
            confirmPassword: false,
          }));
        } else if (passwordValid && confirmPassword && !passwordsMatch) {
          setPasswordError("Passwords do not match.");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: true,
          }));
        } else {
          setPasswordError("");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        }
      } else {
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
      }

      return updated;
    });
  };

  const validateFilesExist = async (files = []) => {
    if (!files || files.length === 0)
      return { isValid: true, invalidFiles: [] };

    const invalidFiles = [];

    for (const fileObj of files) {
      const file = fileObj?.originalFile || fileObj?.file || fileObj;
      const fileName = fileObj?.name || "Unknown file";

      try {
        if (!(file instanceof File)) {
          invalidFiles.push(fileName);
          continue;
        }

        if (typeof file.arrayBuffer === "function") {
          await file.arrayBuffer();
        } else {
          await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve();
            reader.onerror = () => reject(new Error("Unable to read file."));
            reader.readAsArrayBuffer(file);
          });
        }
      } catch (err) {
        console.error(`Error reading file: ${fileName}`, err);
        invalidFiles.push(fileName);
      }
    }

    return {
      isValid: invalidFiles.length === 0,
      invalidFiles,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ Role-based validation
    if (formData.role === "contractor" && !validateStep()) return;
    if (formData.role === "owner" && !validateOwnerStep()) return;
    if (formData.role === "inspector" && !validateInspectorStep()) return;

    // ✅ General field validation
    const validations = [
      validateEmail(formData.email),
      validatePhoneNumber(formData.phone),
      formData?.role !== "inspector" ? validateZipCode(formData.zip) : true,
      formData?.role !== "inspector"
        ? validateRoutingNumber(formData.routingNumber)
        : true,
      formData?.role !== "inspector"
        ? validateAccountNumber(formData.accountNumber)
        : true,
    ];

    if (validations.includes(false)) {
      // toast.error("Please fix validation errors before submitting.");
      return;
    }

    // ✅ Validate uploaded files
    let allFilesValid = true;
    let invalidFileNames = [];

    const fileGroups = [];

    if (formData.role === "contractor") {
      // fileGroups.push(formData.contractorLicense);
      fileGroups.push(formData.photoID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    } else if (formData.role === "owner") {
      if (formData.CopyOfID?.length) fileGroups.push(...formData.CopyOfID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    }

    const { isValid, invalidFiles } = await validateFilesExist(fileGroups);

    if (!isValid) {
      allFilesValid = false;
      setInvalidFiles(invalidFiles); // 🟥 store invalid file names

      setEmptyFields((prev) => ({
        ...prev,
        fileError: true,
      }));

      const fileList = invalidFiles.join(", ");
      toast.warning(
        `Some files could not be read or are missing: ${fileList}. Please re-upload them.`
      );

      console.warn("Invalid files:", invalidFiles);
      return;
    } else {
      setInvalidFiles([]); // clear previous errors if everything’s valid
    }

    // ✅ Build FormData based on role
    const formPayload = new FormData();
    formPayload.append("role", formData.role.toLowerCase());
    formPayload.append("email", formData.email);
    formPayload.append(
      "user_name",
      formData.username || `${formData.firstName} ${formData.lastName}`
    );
    formPayload.append("phone", formData.phone);

    if (formData.password) formPayload.append("password", formData.password);

    // ✅ Shared fields for all non-inspector roles
    if (formData.role !== "inspector") {
      formPayload.append("address", formData.address || "");
      formPayload.append("city", formData.city || "");
      formPayload.append("state", formData.stateName || "");
      formPayload.append("zip", formData.zip || "");
    }

    // ✅ Role-specific data
    if (formData.role === "contractor") {
      formPayload.append("company_name", formData.companyName || "");
      formPayload.append("cmp_found_year", formData.yearFounded || "");
      formPayload.append("no_of_employes", formData.employees || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");

      if (formData.contractorLicense)
        formPayload.append("certificates", formData.contractorLicense);
      if (formData.photoID) formPayload.append("photo_id", formData.photoID);
      if (
        formData.AdditionalDocuments &&
        formData.AdditionalDocuments.length > 0
      ) {
        formData.AdditionalDocuments.forEach((file) => {
          formPayload.append("additional_documents", file);
        });
      }
      // if (formData.formationDoc)
      //   formPayload.append("formation_document", formData.formationDoc);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
    } else if (formData.role === "Project Owner" || formData.role === "owner") {
      formPayload.append("co_owner", formData.coOwnerName || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");

      if (formData.CopyOfID)
        formPayload.append("photo_id", formData.CopyOfID?.[0]);
      // if (formData.KYCBeneficial)
      //   formPayload.append("kyc_ownership_certificate", formData.KYCBeneficial);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
      if (
        formData.AdditionalDocuments &&
        formData.AdditionalDocuments.length > 0
      ) {
        formData.AdditionalDocuments.forEach((file) => {
          formPayload.append("additional_documents", file);
        });
      }
    }

    // ✅ Inspector-specific payload
    else if (formData.role === "inspector") {
      formPayload.append("designation", formData.designation || "");
      // add more inspector fields if needed
    }

    // ✅ Submit
    try {
      setissubmitting(true);
      await axios.post("/cvault/create-user-by-admin/", formPayload, {
        headers: headers,
      });

      toast.success("Registration successful!");
      // setTimeout(() => navigate("/login"), 1500);
      // setLoader(false);
      setEmptyFields(false);
      setFormData({
        email: "",
        role: "owner",
        username: "",
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
        city: "",
        stateName: "",
        zip: "",
        companyName: "",
        yearFounded: "",
        employees: "",
        contractorLicense: "",
        accountHolder: "",
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        coOwnerName: "",
        password: "",
        // formationDoc: null,
        photoID: null,
        // EINLetter: null,
        // IRSForm: null,
        confirmPassword: "",
        // KYCBeneficial: null,
        CopyOfID: null,
        designation: "Commercial Building Inspector",
        AdditionalDocuments: null,
      });
      setUserView(false);
      getUsers();
    } catch (error) {
      console.error(error);
      // setLoader(false);
      setEmptyFields(false);
      // setUserView(false);
      toast.error(error?.response?.data?.error || "Registration failed");
    } finally {
      setissubmitting(false);
    }
  };

  const handleBlur = async (event) => {
    const inputValue = event.target.value;
    if (event.target.name === "email" && !validateEmail(inputValue)) {
      if (inputValue !== "") {
        // toast.error("Invalid email");
        setEmailError("Invalid Email");
      }
    } else if (
      event.target.name === "phone" &&
      !validatePhoneNumber(inputValue)
    ) {
      if (inputValue !== "") {
        // toast.error("Invalid Phone Number");
        setPhoneError("Invalid Phone Number");
      }
    } else if (event.target.name === "zip" && !validateZipCode(inputValue)) {
      // toast.error("Invalid Zip code");
      setZipError("Invalid Zip code");
    } else if (event.target.name === "date" && !validateDate(inputValue)) {
      if (inputValue !== "") {
        toast.error(" Please enter a number between 1 and 30.");
      }
    } else if (
      event.target.name === "cmp_found_year" &&
      !validateYear(inputValue)
    ) {
      if (inputValue !== "") {
        setYearError("Please enter a valid year");
      }
    }
    if (event.target.name === "email" && validateEmail(inputValue)) {
      try {
        var response = await axios.get(
          `/cvault/user-existance/?email=${inputValue}`
        );

        if (response?.data?.result) {
          // setState((prev) => ({
          //   ...prev,
          //   phone: response?.data?.data?.contact_info || "",
          //   user_name: response?.data?.data?.user_name || "",
          //   address: response?.data?.data?.address || "",
          //   city: response?.data?.data?.city || "",
          //   state: response?.data?.data?.state || "",
          //   zip: response?.data?.data?.zip_code || "",
          // }));
          setEmailError("User already exists");
        } else {
          // setState((prev) => ({
          //   ...prev,
          //   phone: "",
          //   user_name: "",
          //   address: "",
          //   city: "",
          //   state: "",
          //   zip: "",
          // }));
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again later");
      }
    }
  };

  const validateDate = (date) => {
    const parsedDate = parseInt(date, 10);
    return !isNaN(parsedDate) && parsedDate >= 1 && parsedDate <= 30;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateYear = (year) => {
    const currentYear = new Date().getFullYear();
    return /^\d{4}$/.test(year) && year >= 1000 && year <= currentYear;
  };

  const formatPhoneNumber = (input) => {
    const digits = input.replace(/\D/g, "").replace(/^1/, "").slice(0, 10); // remove non-digits and trim to 10

    const parts = [];
    if (digits.length > 0) parts.push("(" + digits.slice(0, 3));
    if (digits.length >= 3) parts.push(") " + digits.slice(3, 6));
    if (digits.length >= 6) parts.push("-" + digits.slice(6, 10));

    return "+1 " + parts.join("");
  };

  const validatePhoneNumber = (val) => {
    if (val && typeof val === "string") {
      const regex = /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/;

      // Check format first
      if (!regex.test(val)) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // Remove all non-digit characters
      const digitsOnly = val.replace(/\D/g, "");

      // Check if all digits (after +1) are zeros
      if (/^0+$/.test(digitsOnly.slice(1))) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // If valid, clear any previous errors
      setPhoneNumError("");
      setEmptyFields((prev) => ({
        ...prev,
        phone: false,
      }));

      return true;
    }

    // Handle empty or invalid type
    setPhoneNumError("Phone number is required.");
    setEmptyFields((prev) => ({
      ...prev,
      phone: true,
    }));

    return false;
  };

  const validateRoutingNumber = (value) => {
    const routingNumber = value.trim();

    // Check length
    if (routingNumber.length !== 9) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    // Check if all digits are 0
    if (/^0{9}$/.test(routingNumber)) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    return true;
  };
  const validateAccountNumber = (value) => {
    const accountNumber = value.trim();

    // Check if all characters are zeros (any length)
    if (/^0+$/.test(accountNumber)) {
      setAccountNumError("Please enter a valid account number");
      setEmptyFields((prev) => ({
        ...prev,
        accountNumber: true,
      }));
      return false;
    }

    return true;
  };
  const uploadContractorFields = [
    // {
    //   name: "formationDoc",
    //   label: "Formation Document",
    //   tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
    //   accept: ".pdf, image/png, image/jpeg",
    //   maxSize: 20 * 1024 * 1024, // 20MB
    // },
    {
      name: "photoID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];

  const uploadOwnerFields = [
    // {
    //   name: "KYCBeneficial",
    //   label: "KYC Beneficial Ownership Certificate",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "CopyOfID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];
  const validateZipCode = (value) => {
    const zip = value.trim();

    if (zip.length !== 5) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    // Check if all characters are zeros (any length)
    if (/^0{5}$/.test(zip)) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    return true;
  };

  const filteredRows = rows.filter((r) => {
    const q = search.toLowerCase();
    const matchesSearch =
      r._display.name?.toLowerCase().includes(q) ||
      r._display.email?.toLowerCase().includes(q) ||
      r._display.role?.toLowerCase().includes(q) ||
      r.city?.toLowerCase().includes(q);

    const matchesRole = roleFilter === "" || r._display.role === roleFilter;

    return matchesSearch && matchesRole;
  });

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;
    const sorted = [...filteredRows].sort((a, b) => {
      const aVal = a._display[sortConfig.key];
      const bVal = b._display[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredRows, sortConfig]);

  const toggleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  // ✅ Toggle expand for a single row
  const toggleRow = (id) => {
    setExpandedRowId((prev) => (prev === id ? null : id));
  };

  // 🧮 Pagination
  const paginatedRows = sortedRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const yearOptions = Array.from(
    { length: new Date().getFullYear() - 1899 },
    (_, i) => new Date().getFullYear() - i
  ).map((year) => ({ value: year, label: year }));

  const maxSizes = {
    formationDoc: 20 * 1024 * 1024, // 20 MB
    photoID: 20 * 1024 * 1024, // 20 MB
    EINLetter: 10 * 1024 * 1024, // 10 MB
    IRSForm: 10 * 1024 * 1024, // 10 MB
    CopyOfID: 20 * 1024 * 1024, // 20 MB
    KYCBeneficial: 10 * 1024 * 1024, // 10 MB
    AdditionalDocuments: 10 * 1024 * 1024, // 10 MB
  };

  const allowedTypes = {
    formationDoc: ["application/pdf", "image/png", "image/jpeg"],
    photoID: ["application/pdf", "image/png", "image/jpeg"],
    EINLetter: ["application/pdf"],
    IRSForm: ["application/pdf"],
    CopyOfID: ["application/pdf", "image/png", "image/jpeg"],
    KYCBeneficial: ["application/pdf"],
    AdditionalDocuments: [
      "application/pdf",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ],
  };

  const clearFile = (name) => {
    setFormData((prev) => ({ ...prev, [name]: null }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset the file input value so same file can be uploaded again
    const input = document.getElementById(name);
    if (input) input.value = "";
  };
  return (
    <div className="App">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <>
            <div className="loader-overlay">
              {AImessage && (
                <span className="loader-message">
                  AI is working on fetching the Milestone details from the
                  uploaded Contract. Please wait...
                </span>
              )}
              <BarLoader
                color="#F5AE41"
                width={400}
                height={10}
                className="loader"
                loading={loader}
              />
            </div>
          </>
        )}
      </div>
      <Box sx={{ padding: "10px" }}>
        <div>
          {/* <Box sx={{ padding: "0px 10px" }}>
            <div className="row justify-content-end align-items-center">
              <div className="col-12 col-md-12 d-flex justify-content-between align-items-center gap-2 flex-wrap">
             
                <div className="form-group mb-0">
                  <select
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    style={{
                      height: "35px",
                      borderRadius: "4px",
                      padding: "2px 8px",
                      fontSize: "14px",
                      color: "#2C3E50",
                    }}
                  >
                    <option value="">All Users</option>
                    <option value="owner">Owner</option>
                    <option value="contractor">Contractor</option>
                    <option value="inspector">Inspector</option>
                  </select>
                </div>
                <div className="d-flex align-items-center">
                
                  <div className="form-group mb-0 me-2">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      style={{
                        height: "35px",
                        borderRadius: "4px",
                        padding: "2px 8px",
                        color: "black",
                        fontSize: "14px",
                      }}
                    />
                  </div>

             
                  <button
                    className="btn btn-cvault me-2"
                    onClick={() => {
                      setUserView(true);
                      getUsers();
                      setSearch("");
                      setSelectedRole("contractor");
                    }}
                    style={{ fontSize: "14px" }}
                  >
                    Create User
                  </button>

                 
                  <button
                    className="btn detail-btn"
                    onClick={() => {
                      setPdfmilestone([]);
                      navigate("/admin");
                    }}
                    style={{
                      backgroundColor: "lightgray",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>

            
            <DataGrid
              rows={filteredUsers}
              columns={allColumns.map((column) => ({
                ...column,
                headerClassName,
                renderHeader,
              }))}
              getRowId={(row) => row.id}
              autoHeight
              pageSizeOptions={[10, 25, 50]}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 10, page: 0 },
                },
              }}
              hideFooterSelectedRowCount
              localeText={{ noRowsLabel: "No User(s) found" }}
              style={{ marginTop: "10px" }}
            />
          </Box> */}
          {/* ---------- SEARCH & FILTER BAR ---------- */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // gap: 2,
              mb: 2,
            }}
          >
            {/* Role Filter Dropdown */}

            {/* <TextField
                    select
                    size="small"
                    value={roleFilter}
                    onChange={(e) => setRoleFilter(e.target.value)}
                    sx={{ width: "20%", backgroundColor: "#fff" }}
                    SelectProps={{ native: true }}
                  >
                    <option value="">All Roles</option>
                    <option value="Owner">Owner</option>
                    <option value="Contractor">Contractor</option>
                  </TextField> */}

            <div className="form-group mb-0">
              <select
                name="role"
                style={{ width: "10rem", fontSize: "14px" }}
                className="select-form-control-dropdown form-control"
                value={roleFilter}
                onChange={(e) => {
                  setRoleFilter(e.target.value);
                  setPage(1);
                }}
              >
                {/* <option value="">Select Role</option> */}
                <option value="Contractor">Contractor</option>
                <option value="Owner">Owner</option>
                <option value="Inspector">Inspector</option>
              </select>
            </div>
            {/* Search Box */}
            <div className="d-flex align-items-center">
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search..."
                value={search}
                onChange={(e) => {
                  const value = e.target.value.replace(/^\s+/, ""); // Remove leading spaces only
                  setSearch(value);
                }}
                sx={{ width: "100%", backgroundColor: "#fff" }}
              />
             

              <button
                className="btn detail-btn ms-2"
                onClick={() => navigate("/admin")}
                style={{
                  backgroundColor: "lightgray",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Back
              </button>
            </div>
          </Box>
          {/* ---------- HEADER ROW ---------- */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 0.7fr",
              fontWeight: 600,
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
              p: 1.5,
            }}
          >
            {[
              { key: "name", label: "User Name" },
              { key: "email", label: "Email" },
              { key: "role", label: "Role" },
              { key: "phone", label: "Phone" },
            ].map((col) => (
              <Box
                key={col.key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => toggleSort(col.key)}
              >
                <Typography variant="body2" fontWeight={550}>
                  {col.label}
                </Typography>
                {sortConfig.key === col.key &&
                  (sortConfig.direction === "asc" ? (
                    <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                  ))}
              </Box>
            ))}
            <Typography variant="body2" fontWeight={550}>
              Actions
            </Typography>
          </Box>

          {/* ---------- BODY ---------- */}
          {paginatedRows?.length > 0 ? (
            <>
              {paginatedRows?.map((row) => {
                const expanded = expandedRowId === row._display.id;

                return (
                  <Box
                    key={row._display.id}
                    sx={{ borderBottom: "1px solid #e0e0e0" }}
                  >
                    {/* Row */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 0.7fr",
                        alignItems: "center",
                        p: 1.5,
                        backgroundColor: "#fff",
                      }}
                    >
                      <Typography variant="body2">
                        {row._display.name}
                      </Typography>
                      <Typography variant="body2">
                        {row._display.email}
                      </Typography>
                      <Typography variant="body2">
                        {row._display.role}
                      </Typography>
                      <Typography variant="body2">
                        {row._display.phone}
                      </Typography>

                      <Box
                        sx={{
                          cursor: "pointer",
                          color: "#F5AE41",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                        onClick={() => toggleRow(row._display.id)}
                      >
                        <Typography variant="body2" sx={{ fontWeight: 550 }}>
                          {expanded ? "Close" : "View"}
                        </Typography>
                        {expanded ? (
                          <KeyboardArrowUpIcon fontSize="small" />
                        ) : (
                          <KeyboardArrowDownIcon fontSize="small" />
                        )}
                      </Box>
                    </Box>

                    {/* Expanded Row */}
                    <Collapse in={expanded} timeout={200} unmountOnExit>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          backgroundColor: "#f2f2f2",
                          borderColor: "#eee",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <Grid container spacing={2}>
                          {/* ---------- OTHER NON-DOCUMENT FIELDS ---------- */}
                          <Grid container item spacing={2}>
                            <Grid item xs={12}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 600,
                                  color: "text.secondary",
                                }}
                              >
                                Personal Information
                              </Typography>
                              <div
                                style={{ borderBottom: "1px solid #e0e0e0ff" }}
                                className="mt-2"
                              />
                            </Grid>
                            {Object.entries(row)
                              .filter(([key]) => {
                                const excluded = [
                                  "id",
                                  "_display",
                                  "Contractor_License_Information",
                                  "no_of_employees",
                                  "company_Founded_Year",
                                  "company_Name",
                                  "routing_number",
                                  "account_Number",
                                  "account_Holder_Name",
                                  "bank_name",
                                  "KYC_Beneficial_Ownership_Certificate",
                                  "formation_document",
                                  "IRS_Form_W9",
                                  "photo_id",
                                  "EIN_Confirmation_Letter",
                                  "additional_documents",
                                ];
                                return !excluded.includes(key);
                              })
                              .map(([key, value]) => (
                                <Grid item xs={12} sm={6} md={3} key={key}>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 600,
                                      color: "text.secondary",
                                    }}
                                  >
                                    {key
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (l) => l.toUpperCase())}
                                  </Typography>
                                  {value || "—"}
                                </Grid>
                              ))}
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={3}
                              // key={key}
                              pt={0}
                            >
                              {Object.entries(row)
                                .filter(([key]) =>
                                  [
                                    "KYC_Beneficial_Ownership_Certificate",
                                    "formation_document",
                                    "IRS_Form_W9",
                                    "photo_id",
                                    "EIN_Confirmation_Letter",
                                  ].includes(key)
                                )
                                .map(([key, value]) => (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    key={key}
                                    pt={0}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "text.secondary",
                                      }}
                                    >
                                      {key === "IRS_Form_W9"
                                        ? "IRS Form W-9"
                                        : key === "photo_id"
                                        ? "Photo ID"
                                        : key
                                            .replace(/_/g, " ")
                                            .replace(/\b\w/g, (l) =>
                                              l.toUpperCase()
                                            )}
                                    </Typography>

                                    {value ? (
                                      <div
                                        style={{
                                          width: "160px",
                                          display: "flex",
                                          alignItems: "center",
                                          border: "1px solid lightgray",
                                          borderRadius: "4px",
                                          padding: "5px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          viewFiles(value, true, key)
                                        }
                                      >
                                        <Tooltip title="Click here to view">
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <DescriptionIcon
                                              style={{
                                                fontSize: 26,
                                                color: "#F5AE41",
                                              }}
                                            />
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                color: "#1f1f1fff",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                wordBreak: "break-word",
                                                maxWidth: "100%",
                                              }}
                                            >
                                              {(() => {
                                                const fileName = value
                                                  .split("/")
                                                  .pop();
                                                const ext = fileName
                                                  .split(".")
                                                  .pop();
                                                const nameWithoutExt =
                                                  fileName.replace(
                                                    `.${ext}`,
                                                    ""
                                                  );
                                                return nameWithoutExt.length > 8
                                                  ? `${nameWithoutExt.slice(
                                                      0,
                                                      8
                                                    )}...${ext}`
                                                  : fileName;
                                              })()}
                                            </Typography>
                                          </div>
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      "—"
                                    )}
                                  </Grid>
                                ))}
                            </Grid>
                          </Grid>

                          {row._display.role === "Owner" && (
                            <Grid container item spacing={2}>
                              {Object.entries(row)
                                .filter(
                                  ([key]) => key === "additional_documents"
                                )
                                .map(([key, value]) => (
                                  <Grid item xs={12} md={12} key={key} pt={0}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "text.secondary",
                                      }}
                                    >
                                      Additional Documents
                                    </Typography>

                                    {Array.isArray(value) &&
                                    value.length > 0 ? (
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns:
                                            "repeat(auto-fill, minmax(160px, 1fr))",
                                          gap: "12px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        {(showAll
                                          ? value
                                          : value.slice(0, 3)
                                        ).map((file, idx) => (
                                          <div
                                            key={idx}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              border: "1px solid lightgray",
                                              borderRadius: "4px",
                                              padding: "5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              viewFiles(file, true, key)
                                            }
                                          >
                                            <Tooltip title="Click here to view">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "10px",
                                                }}
                                              >
                                                <DescriptionIcon
                                                  style={{
                                                    fontSize: 26,
                                                    color: "#F5AE41",
                                                  }}
                                                />
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    color: "#1f1f1fff",
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    wordBreak: "break-word",
                                                    maxWidth: "100%",
                                                  }}
                                                >
                                                  {(() => {
                                                    const fileName = file
                                                      .split("/")
                                                      .pop();
                                                    const ext = fileName
                                                      .split(".")
                                                      .pop();
                                                    const nameWithoutExt =
                                                      fileName.replace(
                                                        `.${ext}`,
                                                        ""
                                                      );
                                                    return nameWithoutExt.length >
                                                      8
                                                      ? `${nameWithoutExt.slice(
                                                          0,
                                                          8
                                                        )}...${ext}`
                                                      : fileName;
                                                  })()}
                                                </Typography>
                                              </div>
                                            </Tooltip>
                                          </div>
                                        ))}

                                        {value.length > 3 && (
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowAll(!showAll);
                                            }}
                                            style={{
                                              color: "#0d6efd",
                                              cursor: "pointer",
                                              marginTop: "4px",
                                              fontSize: "13px",
                                              fontWeight: 500,
                                            }}
                                          >
                                            {showAll
                                              ? "View Less"
                                              : `View All (${
                                                  value.length - 3
                                                })`}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      "—"
                                    )}
                                  </Grid>
                                ))}
                            </Grid>
                          )}

                          {/* ---------- COMPANY INFO ROW ---------- */}
                          {row._display.role === "Contractor" && (
                            <Grid container item spacing={2}>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  Business Information
                                </Typography>
                                <div
                                  style={{
                                    borderBottom: "1px solid #e0e0e0ff",
                                  }}
                                  className="mt-2"
                                />
                              </Grid>
                              {Object.entries(row)
                                .filter(([key]) =>
                                  [
                                    "Contractor_License_Information",
                                    "no_of_employees",
                                    "company_Founded_Year",
                                    "company_Name",
                                  ].includes(key)
                                )
                                .map(([key, value]) => (
                                  <Grid item xs={12} sm={6} md={3} key={key}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "text.secondary",
                                      }}
                                    >
                                      {key
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (l) =>
                                          l.toUpperCase()
                                        )}
                                    </Typography>
                                    {value || "—"}
                                  </Grid>
                                ))}
                            </Grid>
                          )}
                          {row._display.role === "Contractor" && (
                            <Grid container item spacing={2}>
                              {Object.entries(row)
                                .filter(
                                  ([key]) => key === "additional_documents"
                                )
                                .map(([key, value]) => (
                                  <Grid item xs={12} md={12} key={key} pt={0}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "text.secondary",
                                      }}
                                    >
                                      Additional Documents
                                    </Typography>

                                    {Array.isArray(value) &&
                                    value.length > 0 ? (
                                      <div
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns:
                                            "repeat(auto-fill, minmax(160px, 1fr))",
                                          gap: "12px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        {(showAll
                                          ? value
                                          : value.slice(0, 3)
                                        ).map((file, idx) => (
                                          <div
                                            key={idx}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              border: "1px solid lightgray",
                                              borderRadius: "4px",
                                              padding: "5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              viewFiles(file, true, key)
                                            }
                                          >
                                            <Tooltip title="Click here to view">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "10px",
                                                }}
                                              >
                                                <DescriptionIcon
                                                  style={{
                                                    fontSize: 26,
                                                    color: "#F5AE41",
                                                  }}
                                                />
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    color: "#1f1f1fff",
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    wordBreak: "break-word",
                                                    maxWidth: "100%",
                                                  }}
                                                >
                                                  {(() => {
                                                    const fileName = file
                                                      .split("/")
                                                      .pop();
                                                    const ext = fileName
                                                      .split(".")
                                                      .pop();
                                                    const nameWithoutExt =
                                                      fileName.replace(
                                                        `.${ext}`,
                                                        ""
                                                      );
                                                    return nameWithoutExt.length >
                                                      8
                                                      ? `${nameWithoutExt.slice(
                                                          0,
                                                          8
                                                        )}...${ext}`
                                                      : fileName;
                                                  })()}
                                                </Typography>
                                              </div>
                                            </Tooltip>
                                          </div>
                                        ))}

                                        {value.length > 3 && (
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowAll(!showAll);
                                            }}
                                            style={{
                                              color: "#0d6efd",
                                              cursor: "pointer",
                                              marginTop: "4px",
                                              fontSize: "13px",
                                              fontWeight: 500,
                                            }}
                                          >
                                            {showAll
                                              ? "View Less"
                                              : `View All (${
                                                  value.length - 3
                                                })`}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      "—"
                                    )}
                                  </Grid>
                                ))}
                            </Grid>
                          )}

                          {/* ---------- BANK INFO ROW ---------- */}
                          {row._display.role !== "Inspector" && (
                            <Grid container item spacing={2}>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  Bank Information
                                </Typography>
                                <div
                                  style={{
                                    borderBottom: "1px solid #e0e0e0ff",
                                  }}
                                  className="mt-2"
                                />
                              </Grid>
                              {Object.entries(row)
                                .filter(([key]) =>
                                  [
                                    "routing_number",
                                    "account_Number",
                                    "account_Holder_Name",
                                    "bank_name",
                                  ].includes(key)
                                )
                                .map(([key, value]) => (
                                  <Grid item xs={12} sm={6} md={3} key={key}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "text.secondary",
                                      }}
                                    >
                                      {key
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (l) =>
                                          l.toUpperCase()
                                        )}
                                    </Typography>
                                    {value || "—"}
                                  </Grid>
                                ))}
                            </Grid>
                          )}
                        </Grid>
                      </Paper>
                    </Collapse>
                  </Box>
                );
              })}
            </>
          ) : (
            <>
               <span className="d-flex justify-content-center my-2 text-muted">
          {tableLoader ? "fetching records..." : "No results found"}
        </span>
            </>
          )}
          {/* ---------- PAGINATION ---------- */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              backgroundColor: "#fff",
              borderTop: "1px solid #e0e0e0",
            }}
          >
            <TablePagination
              component="div"
              count={sortedRows.length}
              page={page - 1}
              onPageChange={(e, newPage) => setPage(newPage + 1)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(1);
              }}
              rowsPerPageOptions={[5, 10, 15]}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}–${to} of ${count}`
              }
            />
          </Box>
        </div>
      </Box>

      <Drawer
        variant="temporary"
        anchor="right"
        open={userView}
        onClose={() => {
          setUserView(false);
          setSearch("");
          setEmailError("");
          setPhoneError("");
          setZipError("");
          setRoutingNumError("");
          setAccountNumError("");
          setYearError("");
          setEmptyFields(false);
          setFormData({
            email: "",
            role: "owner",
            username: "",
            firstName: "",
            lastName: "",
            phone: "",
            address: "",
            city: "",
            stateName: "",
            zip: "",
            companyName: "",
            yearFounded: "",
            employees: "",
            contractorLicense: "",
            accountHolder: "",
            bankName: "",
            routingNumber: "",
            accountNumber: "",
            coOwnerName: "",
            password: "",
            // formationDoc: null,
            photoID: null,
            // EINLetter: null,
            // IRSForm: null,
            confirmPassword: "",
            // KYCBeneficial: null,
            CopyOfID: null,
            designation: "Commercial Building Inspector",
            AdditionalDocuments: null,
          });
        }}
        sx={{
          width: "60%",
          flexShrink: 0,
          "& .MuiDrawer-paper": { width: "60%", boxSizing: "border-box" },
        }}
      >
        {/* ===== HEADER ===== */}

        <div
          style={{
            position: "sticky",
            top: 0,
            background: "#fff",
            zIndex: 100,
            padding: "16px 24px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="fw-bold m-0" style={{ fontSize: "22px" }}>
            Create User
          </h4>
          <CloseIcon
            onClick={() => {
              setUserView(false);
              setSearch("");
              setEmptyFields(false);
              setEmailError("");
              setPhoneError("");
              setZipError("");
              setYearError("");
              setFormData({
                email: "",
                role: "owner",
                username: "",
                firstName: "",
                lastName: "",
                phone: "",
                address: "",
                city: "",
                stateName: "",
                zip: "",
                companyName: "",
                yearFounded: "",
                employees: "",
                contractorLicense: "",
                accountHolder: "",
                bankName: "",
                routingNumber: "",
                accountNumber: "",
                coOwnerName: "",
                password: "",
                // formationDoc: null,
                photoID: null,
                // EINLetter: null,
                // IRSForm: null,
                confirmPassword: "",
                // KYCBeneficial: null,
                CopyOfID: null,
                designation: "Commercial Building Inspector",
                AdditionalDocuments: null,
              });
            }}
            style={{
              cursor: "pointer",
              fontSize: "28px",
            }}
          />
        </div>
        {/* ===== CONTENT SCROLL AREA ===== */}
        <form
          onSubmit={handleSubmit}
          id="owner-form"
          style={{
            overflowX: "hidden",
          }}
        >
          <div
            // className="mt-3"
            style={{
              flexGrow: 1,
              overflowY: "auto",
            }}
          >
            <Box sx={{ flex: 1, overflowY: "auto", p: 0, overflowX: "hidden" }}>
              {/* OWNER DIRECT FORM */}
              {formData.role === "owner" && (
                <>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Personal Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-12 col-md-4">
                      <div className="form-group">
                        <label htmlFor="role">
                          User Type<span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="role"
                          style={{ width: "100%", fontSize: "14px" }}
                          className="select-form-control-dropdown form-control"
                          value={formData.role}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                        >
                          {/* <option value="">Select Role</option> */}
                          <option value="owner">Owner</option>
                          <option value="contractor">Contractor</option>
                          <option value="inspector">Inspector</option>
                        </select>
                      </div>
                    </div>
                    {/* <div>
              {errorMsg !== "" && (
                <span style={{ color: "red" }}>{errorMsg}</span>
              )}
            </div> */}
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="firstName"
                        placeholder="Enter First Name"
                        maxLength={60}
                        ref={firstNameRef}
                        className="form-control"
                        value={formData.firstName}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                        style={borderStyle("firstName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="lastName"
                        className="form-control"
                        placeholder="Enter Last Name"
                        maxLength={40}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.lastName}
                        onChange={handleChange}
                        style={borderStyle("lastName")}
                      />
                    </div>
                    <div className="col-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="email"
                        placeholder="Enter Email"
                        maxLength={255}
                        name="email"
                        onBlur={handleBlur}
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        style={borderStyle("email")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        // min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="phone"
                        placeholder="Enter Phone Number"
                        className="form-control"
                        value={formData.phone}
                        onBlur={(e) => validatePhoneNumber(e.target.value)}
                        onChange={handleChange}
                        style={borderStyle("phone")}
                      />
                    </div>

                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Co-Owner Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="coOwnerName"
                        placeholder="Enter Co-Owner Name"
                        maxLength={500}
                        className="form-control"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.coOwnerName}
                        onChange={handleChange}
                        style={borderStyle("coOwnerName")}
                      />
                    </div>
                    {emailErrors && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {emailErrors}
                        </span>
                      </div>
                    )}
                    {phoneNumError && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {phoneNumError}
                        </span>
                      </div>
                    )}
                    <div className="col-md-12 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Address <span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text"
                        name="address"
                        rows={3}
                        // readOnly={issubmitting}
                        className="form-control"
                        placeholder="Enter Address"
                        maxLength={100}
                        value={formData.address}
                        onChange={handleChange}
                        style={borderStyle("address")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        City <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="city"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        placeholder="Enter City"
                        maxLength={100}
                        value={formData.city}
                        onChange={handleChange}
                        style={borderStyle("city")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        State <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="stateName"
                        placeholder="Enter State"
                        maxLength={100}
                        className="form-control"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.stateName}
                        onChange={handleChange}
                        style={borderStyle("stateName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Zip <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="number"
                        name="zip"
                        min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        placeholder="Enter Zip"
                        onBlur={(e) => validateZipCode(e.target.value)}
                        value={formData.zip}
                        onChange={handleChange}
                        style={borderStyle("zip")}
                      />
                    </div>
                    {zipError && (
                      <div className={`col-12 mt-2`}>
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {zipError}
                        </span>
                      </div>
                    )}
                    {uploadOwnerFields.map(
                      ({ name, label, tooltip, accept }) => (
                        <div className="col-12 col-md-6 mt-3" key={name}>
                          {/* Label + Tooltip */}
                          <div
                            className="d-flex align-items-center justify-content-start mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            <label className="mb-0">
                              {label}{" "}
                              {label !== "EIN Confirmation Letter" ? (
                                <span className="text-danger">*</span>
                              ) : (
                                <span></span>
                              )}
                            </label>
                            <Tooltip title={tooltip}>
                              <span>
                                <IoMdInformationCircleOutline
                                  fontSize={"16px"}
                                  className="ms-1"
                                />
                              </span>
                            </Tooltip>
                          </div>

                          {/* Hidden Input */}
                          <input
                            readOnly={issubmitting}
                            type="file"
                            id={name}
                            name={name}
                            key={name}
                            onChange={handleChange}
                            disabled={issubmitting}
                            accept={accept}
                            multiple={name !== "CopyOfID"}
                            style={{ display: "none" }}
                          />

                          {/* Conditional rendering for CopyOfID */}
                          {name === "CopyOfID" ? (
                            // --- Single File Layout (like photoID) ---
                            <>
                              {!formData[name] ? (
                                <label
                                  htmlFor={name}
                                  className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    border: emptyFields[name]
                                      ? "1px solid red"
                                      : "1px dashed #878787ff",
                                    color: "878787ff",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                >
                                  <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                  Upload
                                </label>
                              ) : (
                                <div
                                  className="d-flex align-items-center justify-content-between border rounded px-2 py-2 mt-2"
                                  style={{
                                    fontSize: "13px",
                                    backgroundColor: invalidFiles.includes(
                                      formData[name]?.[0]?.name
                                    )
                                      ? "#fff"
                                      : "#fff",
                                    border: invalidFiles.includes(
                                      formData[name]?.[0]?.name
                                    )
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                    borderRadius: "20px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="text-truncate"
                                    style={{ maxWidth: "80%" }}
                                    onClick={() => {
                                      const file = formData[name]?.[0];
                                      if (file) {
                                        const url = URL.createObjectURL(file);
                                        setSelectedPdfFile(url);
                                        setPreviewModaTitle("Photo ID");
                                        setPreviewModal(true);
                                      }
                                    }}
                                  >
                                    <TextSnippetIcon
                                      className="me-2"
                                      style={{ fontSize: 26, color: "#F5AE41" }}
                                    />{" "}
                                    {formData[name]?.[0]?.name}
                                  </div>
                                  <i
                                    className="fa-solid fa-xmark ms-2"
                                    style={{ cursor: "pointer", color: "grey" }}
                                    onClick={() => clearFile(name)}
                                  ></i>
                                </div>
                              )}
                            </>
                          ) : (
                            // --- Default Layout for multi-file fields ---
                            <>
                              <label
                                htmlFor={name}
                                className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease-in-out",
                                  border: emptyFields[name]
                                    ? "1px solid red"
                                    : "1px dashed #878787ff",
                                  color: "878787ff",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                              >
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                Upload
                              </label>

                              {Array.isArray(formData[name]) &&
                                formData[name].length > 0 && (
                                  <div className="d-flex flex-wrap mt-2 gap-2">
                                    {formData[name].map((file, index) => (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center border rounded px-2 py-1"
                                        style={{
                                          fontSize: "13px",
                                          backgroundColor:
                                            invalidFiles.includes(file.name)
                                              ? "#fff"
                                              : "#fff",
                                          border: invalidFiles.includes(
                                            file.name
                                          )
                                            ? "1px solid red"
                                            : "1px solid #ccc",
                                          borderRadius: "20px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <span
                                          className="text-truncate"
                                          style={{ maxWidth: "120px" }}
                                          onClick={() => {
                                            const filename = file.name;
                                            if (!filename) return;

                                            const url =
                                              URL.createObjectURL(file);
                                            const fileType = file.type;

                                            // Handle PDFs
                                            if (
                                              fileType === "application/pdf"
                                            ) {
                                              setSelectedPdfFile(url);
                                              setPreviewModaTitle(
                                                "Additional Documents"
                                              );
                                              setPreviewModal(true);
                                            }
                                            // For other file types (Excel, Word, etc.)
                                            else {
                                              const link =
                                                document.createElement("a");
                                              link.href = url;
                                              link.download = filename;
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                              URL.revokeObjectURL(url);
                                            }
                                          }}
                                        >
                                          <TextSnippetIcon
                                            className="me-2"
                                            style={{
                                              fontSize: 26,
                                              color: "#F5AE41",
                                            }}
                                          />{" "}
                                          {file.name}
                                        </span>
                                        <i
                                          className="fa-solid fa-xmark ms-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "grey",
                                          }}
                                          onClick={() =>
                                            clearSingleFile(name, index)
                                          }
                                        ></i>
                                      </div>
                                    ))}
                                  </div>
                                )}
                            </>
                          )}

                          {/* Error Text */}
                          {errors[name] && (
                            <div
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[name]}
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                    className="mt-2"
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Bank Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Holder <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="accountHolder"
                        className="form-control"
                        value={formData.accountHolder}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Account Holder"
                        maxLength={100}
                        style={borderStyle("accountHolder")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Bank Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="bankName"
                        className="form-control"
                        value={formData.bankName}
                        onChange={handleChange}
                        placeholder="Enter Bank Name "
                        maxLength={100}
                        style={borderStyle("bankName")}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <div
                        className="d-flex align-items-center justify-content-start"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        <label
                          className="mb-1"
                          style={{ fontWeight: 500, fontSize: "14px" }}
                        >
                          Wire Routing Number{" "}
                          <span className="text-muted">
                            (Wire transfers only, no ACH)
                          </span>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
           
              <span>
                <IoMdInformationCircleOutline
                  fontSize={"16px"}
                  className="ms-1 mb-1"
                />
              </span>
            </Tooltip> */}
                      </div>
                      <input
                        // readOnly={issubmitting}
                        name="routingNumber"
                        type="number"
                        className="form-control"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.routingNumber}
                        onBlur={(e) => validateRoutingNumber(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 9) {
                            handleChange(e);
                          }
                        }}
                        min={0}
                        max={999999999}
                        placeholder="Enter Routing Number"
                        style={borderStyle("routingNumber")}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label
                        // className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Number <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="accountNumber"
                        className="form-control"
                        onBlur={(e) => validateAccountNumber(e.target.value)}
                        min={0}
                        max={99999999999999999}
                        placeholder="Enter  Account Number "
                        type="number"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.accountNumber}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow empty string for deletion
                          if (value === "" || value.length <= 17) {
                            handleChange(e);
                          }
                        }}
                        style={borderStyle("accountNumber")}
                      />
                    </div>
                    {routingNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {routingNumError}
                        </span>
                      </div>
                    )}
                    {accountNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {accountNumError}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* Inspector */}
              {formData.role === "inspector" && (
                <>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Personal Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-12 col-md-4">
                      <div className="form-group">
                        <label htmlFor="role">
                          User Type<span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="role"
                          style={{ width: "100%", fontSize: "14px" }}
                          className="select-form-control-dropdown form-control"
                          value={formData.role}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                        >
                          {/* <option value="">Select Role</option> */}
                          <option value="owner">Owner</option>
                          <option value="contractor">Contractor</option>
                          <option value="inspector">Inspector</option>
                        </select>
                      </div>
                    </div>
                    {/* <div>
              {errorMsg !== "" && (
                <span style={{ color: "red" }}>{errorMsg}</span>
              )}
            </div> */}
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="firstName"
                        placeholder="Enter First Name"
                        maxLength={60}
                        ref={firstNameRef}
                        className="form-control"
                        value={formData.firstName}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                        style={borderStyle("firstName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="lastName"
                        className="form-control"
                        placeholder="Enter Last Name"
                        maxLength={40}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.lastName}
                        onChange={handleChange}
                        style={borderStyle("lastName")}
                      />
                    </div>
                    <div className="col-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="email"
                        placeholder="Enter Email"
                        maxLength={255}
                        name="email"
                        onBlur={handleBlur}
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        style={borderStyle("email")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        // min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="phone"
                        placeholder="Enter Phone Number"
                        className="form-control"
                        value={formData.phone}
                        onBlur={(e) => validatePhoneNumber(e.target.value)}
                        onChange={handleChange}
                        style={borderStyle("phone")}
                      />
                    </div>

                    <div className="col-12 col-md-4 ">
                      <div className="form-group">
                        <label htmlFor="designation">
                          Inspector Designation
                          <span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="designation"
                          className="select-form-control-dropdown form-control"
                          value={formData.designation}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                          style={borderStyle("designation")}
                        >
                          <option value="" disabled>
                            Select Designation
                          </option>
                          <option value="Commercial Building Inspector">
                            Commercial Building Inspector
                          </option>
                          <option value="Residential Building Inspector">
                            Residential Building Inspector
                          </option>
                          <option value="Combination Inspector">
                            Combination Inspector
                          </option>
                        </select>
                      </div>
                      {/* </div> */}
                    </div>
                    {emailErrors && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {emailErrors}
                        </span>
                      </div>
                    )}
                    {phoneNumError && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {phoneNumError}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* CONTRACTOR MULTI-STEP FORM */}
              {formData.role === "contractor" && (
                <>
                  {step === 1 && (
                    <>
                      {/* <h6 className="mb-3">Personal Details</h6> */}
                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Personal Information
                        </h5>
                      </div>
                      <div className="row p-3">
                        <div className="col-12 col-md-4">
                          <div className="form-group">
                            <label htmlFor="role">
                              User Type
                              <span className="text-danger fs-4">*</span>
                            </label>
                            <select
                              name="role"
                              style={{ width: "100%", fontSize: "14px" }}
                              className="select-form-control-dropdown form-control"
                              value={formData.role}
                              onChange={(e) => {
                                handleChange(e);
                                // setEmailError("");
                                setEmptyFields(false);
                              }}
                              onBlur={handleBlur}
                            >
                              {/* <option value="">Select Role</option> */}
                              <option value="owner">Owner</option>
                              <option value="contractor">Contractor</option>
                              <option value="inspector">Inspector</option>
                            </select>
                          </div>
                        </div>
                        {/* <div>
              {errorMsg !== "" && (
                <span style={{ color: "red" }}>{errorMsg}</span>
              )}
            </div> */}
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="firstName"
                            placeholder="Enter First Name"
                            maxLength={60}
                            className="form-control"
                            ref={firstNameRef}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.firstName}
                            onChange={handleChange}
                            style={borderStyle("firstName")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="lastName"
                            className="form-control"
                            value={formData.lastName}
                            placeholder="Enter Last Name"
                            maxLength={40}
                            onChange={handleChange}
                            style={borderStyle("lastName")}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="col-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="email"
                            type="email"
                            onBlur={handleBlur}
                            className="form-control"
                            placeholder="Enter Email"
                            maxLength={255}
                            value={formData.email}
                            onChange={handleChange}
                            style={borderStyle("email")}
                          />
                        </div>
                        <div className="col-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="phone"
                            className="form-control"
                            type="text"
                            min={0}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter Phone Number"
                            value={formData.phone}
                            onBlur={(e) => validatePhoneNumber(e.target.value)}
                            onChange={handleChange}
                            style={borderStyle("phone")}
                          />
                        </div>
                        {emailErrors && (
                          <div
                            className={
                              emailErrors && phoneNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {emailErrors}
                            </span>
                          </div>
                        )}
                        {phoneNumError && (
                          <div
                            className={
                              emailErrors && phoneNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {phoneNumError}
                            </span>
                          </div>
                        )}

                        <div className="col-md-12 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Address <span className="text-danger">*</span>
                          </label>
                          <textarea
                            name="address"
                            rows={3}
                            className="form-control"
                            // readOnly={issubmitting}
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Enter Address"
                            maxLength={100}
                            style={borderStyle("address")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            City <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="city"
                            className="form-control"
                            value={formData.city}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter City"
                            maxLength={100}
                            onChange={handleChange}
                            style={borderStyle("city")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            State <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="stateName"
                            className="form-control"
                            value={formData.stateName}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter State"
                            maxLength={100}
                            style={borderStyle("stateName")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Zip <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="zip"
                            type="number"
                            min={0}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            className="form-control"
                            value={formData.zip}
                            onChange={handleChange}
                            onBlur={(e) => validateZipCode(e.target.value)}
                            style={borderStyle("zip")}
                            placeholder="Enter Zip"
                          />
                        </div>
                        {zipError && (
                          <div className={`col-12 mt-2`}>
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {zipError}
                            </span>
                          </div>
                        )}
                        {uploadContractorFields.map(
                          ({ name, label, tooltip, accept }) => (
                            <>
                              {name === "photoID" && (
                                <div className="col-12 mt-3" key={name}>
                                  <div
                                    className="d-flex align-items-center justify-content-start mb-1"
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    <label className="mb-0">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Tooltip title={tooltip}>
                                      <span>
                                        <IoMdInformationCircleOutline
                                          fontSize={"16px"}
                                          className="ms-1 mb-1"
                                        />
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {/* Hidden Input */}
                                  <input
                                    readOnly={issubmitting}
                                    type="file"
                                    id={name}
                                    name={name}
                                    onChange={handleChange}
                                    disabled={issubmitting}
                                    accept={accept}
                                    style={{ display: "none" }}
                                  />

                                  {/* Upload Button or File Display */}
                                  {!formData[name] ? (
                                    <label
                                      htmlFor={name}
                                      className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        borderRadius: "6px",
                                        height: "50px",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease-in-out",
                                        border: emptyFields[name]
                                          ? "1px solid red"
                                          : "1px dashed #878787ff",
                                        color: "878787ff",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.currentTarget.style.background =
                                          "#fff")
                                      }
                                      onMouseOut={(e) =>
                                        (e.currentTarget.style.background =
                                          "#fff")
                                      }
                                    >
                                      <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                      Upload
                                    </label>
                                  ) : (
                                    <div
                                      className="d-flex align-items-center border rounded px-2 py-2 justify-content-between"
                                      style={{
                                        fontSize: "13px",
                                        backgroundColor: invalidFiles.includes(
                                          formData[name]?.name
                                        )
                                          ? "#fff" // 🟥 light red background if invalid
                                          : "#fff",
                                        border: invalidFiles.includes(
                                          formData[name]?.name
                                        )
                                          ? "1px solid red"
                                          : "1px solid #ccc",
                                        borderRadius: "20px",
                                        transition: "all 0.3s ease-in-out",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div
                                        className="text-truncate"
                                        style={{ maxWidth: "80%" }}
                                        onClick={() => {
                                          const file = formData[name]?.[0];
                                          if (file) {
                                            const url =
                                              URL.createObjectURL(file);
                                            setSelectedPdfFile(url);
                                            setPreviewModaTitle("Photo ID");
                                            setPreviewModal(true);
                                          }
                                        }}
                                      >
                                        <TextSnippetIcon
                                          className="me-2"
                                          style={{
                                            fontSize: 26,
                                            color: "#F5AE41",
                                          }}
                                        />{" "}
                                        {formData[name].name}
                                        {/* {invalidFiles.includes(
                                          formData[name]?.name
                                        ) && (
                                          <i
                                            className="fa-solid fa-triangle-exclamation ms-2"
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                            title="This file could not be read. Please re-upload."
                                          ></i>
                                        )} */}
                                      </div>
                                      <i
                                        className="fa-solid fa-xmark ms-2"
                                        style={{
                                          cursor: "pointer",
                                          color: "grey",
                                        }}
                                        onClick={() => clearFile(name)}
                                      ></i>
                                    </div>
                                  )}

                                  {/* Error Text */}
                                  {errors[name] && (
                                    <div
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors[name]}
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )
                        )}
                      </div>

                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                        className="mt-2"
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Business Information
                        </h5>
                      </div>

                      {/* <h6 className="mb-3"> Company Details</h6> */}
                      <div className="row p-3">
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Company Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="companyName"
                            className="form-control"
                            value={formData.companyName}
                            onChange={handleChange}
                            // onKeyDown={(e) => {
                            //   // Block invalid keys before they appear
                            //   if (
                            //     !/^[a-zA-Z\s]$/.test(e.key) &&
                            //     e.key !== "Backspace" &&
                            //     e.key !== "Tab" &&
                            //     e.key !== "ArrowLeft" &&
                            //     e.key !== "ArrowRight" &&
                            //     e.key !== "Delete"
                            //   ) {
                            //     e.preventDefault();
                            //   }
                            // }}
                            style={borderStyle("companyName")}
                            placeholder="Enter Company Name"
                            maxLength={500}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Year Founded <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={yearOptions}
                            value={yearOptions.find(
                              (option) => option.value === formData.yearFounded
                            )} // Ensure selected year is reflected
                            onChange={(selected) =>
                              handleChange({
                                target: {
                                  name: "yearFounded",
                                  value: selected.value,
                                },
                              })
                            }
                            isDisabled={issubmitting}
                            // readOnly={issubmitting}
                            className="w-100"
                            styles={{
                              control: (base) => ({
                                ...base,
                                ...borderStyle("yearFounded"),
                                minHeight: "34px",

                                marginTop: "2.5px",
                              }),
                              option: (base) => ({
                                ...base,
                                paddingTop: 4,
                                paddingBottom: 4,
                              }),
                            }}
                            placeholder="Select Founded Year"
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Number of Employees{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            type="number"
                            name="employees"
                            className="form-control"
                            min={1}
                            placeholder="Enter Number of Employees"
                            value={formData.employees}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEmptyFields((prev) => ({
                                ...prev,
                                employees: false,
                              }));

                              if (value.length > 10) {
                                // If user types more than 10 characters, ignore extra input
                                return;
                              }

                              if (value === "" || parseInt(value) < 1) {
                                setFormData((prev) => ({
                                  ...prev,
                                  employees: "",
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  employees: parseInt(value),
                                }));
                              }
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "." ||
                                (e.key === "0" && e.target.value === "")
                              ) {
                                e.preventDefault();
                              }
                            }}
                            style={borderStyle("employees")}
                          />
                        </div>
                        <div className="col-12 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Contractor License Information{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="contractorLicense"
                            className="form-control"
                            placeholder="Enter Contractor License Information"
                            value={formData.contractorLicense}
                            onChange={handleChange}
                            style={borderStyle("contractorLicense")}
                          />
                        </div>
                        {uploadContractorFields.map(
                          ({ name, label, tooltip, accept }) => (
                            <>
                              {name !== "photoID" && (
                                <div className="col-12 mt-3" key={name}>
                                  <div
                                    className="d-flex align-items-center justify-content-start mb-1"
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    <label className="mb-0">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Tooltip title={tooltip}>
                                      <span>
                                        <IoMdInformationCircleOutline
                                          fontSize={"16px"}
                                          className="ms-1 mb-1"
                                        />
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {/* Hidden Input (Multiple File Support) */}
                                  <input
                                    readOnly={issubmitting}
                                    type="file"
                                    id={name}
                                    name={name}
                                    onChange={(e) => handleChange(e, name)}
                                    disabled={issubmitting}
                                    accept={accept}
                                    multiple
                                    style={{ display: "none" }}
                                  />

                                  {/* Upload Button */}
                                  <label
                                    htmlFor={name}
                                    className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                    style={{
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      height: "50px",
                                      transition: "all 0.2s ease-in-out",
                                      border: emptyFields[name]
                                        ? "1px solid red"
                                        : "1px dashed #878787ff",
                                      color: "878787ff",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.currentTarget.style.background =
                                        "#fff")
                                    }
                                    onMouseOut={(e) =>
                                      (e.currentTarget.style.background =
                                        "#fff")
                                    }
                                  >
                                    <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                    Upload
                                  </label>

                                  {/* Display Uploaded Files as Chips */}
                                  {formData[name]?.length > 0 && (
                                    <div className="d-flex flex-wrap mt-2 gap-2">
                                      {formData[name].map((file, index) => (
                                        <div
                                          key={index}
                                          className="d-flex align-items-center border rounded px-2 py-1"
                                          style={{
                                            fontSize: "13px",
                                            backgroundColor:
                                              invalidFiles.includes(file.name)
                                                ? "#fff" // light red background
                                                : "#fff",
                                            border: invalidFiles.includes(
                                              file.name
                                            )
                                              ? "1px solid red"
                                              : "1px solid #ccc",
                                            borderRadius: "20px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span
                                            className="text-truncate"
                                            style={{ maxWidth: "120px" }}
                                            onClick={() => {
                                              const filename = file.name;
                                              if (!filename) return;

                                              const url =
                                                URL.createObjectURL(file);
                                              const fileType = file.type;

                                              // Handle PDFs
                                              if (
                                                fileType === "application/pdf"
                                              ) {
                                                setSelectedPdfFile(url);
                                                setPreviewModaTitle(
                                                  "Additional Documents"
                                                );
                                                setPreviewModal(true);
                                              }
                                              // For other file types (Excel, Word, etc.)
                                              else {
                                                const link =
                                                  document.createElement("a");
                                                link.href = url;
                                                link.download = filename;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                                URL.revokeObjectURL(url);
                                              }
                                            }}
                                          >
                                            <TextSnippetIcon
                                              className="me-2"
                                              style={{
                                                fontSize: 26,
                                                color: "#F5AE41",
                                              }}
                                            />{" "}
                                            {file.name}
                                          </span>
                                          <i
                                            className="fa-solid fa-xmark ms-2"
                                            style={{
                                              cursor: "pointer",
                                              color: "grey",
                                            }}
                                            onClick={() =>
                                              clearSingleFile(name, index)
                                            }
                                          ></i>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {errors[name] && (
                                    <div
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors[name]}
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )
                        )}
                      </div>
                      {/* <h6 className="mb-2 mt-3">Bank Details</h6> */}
                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Bank Information
                        </h5>
                      </div>
                      <div className="row p-3">
                        <div className="col-md-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Account Holder{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="accountHolder"
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            className="form-control"
                            value={formData.accountHolder}
                            onChange={handleChange}
                            placeholder="Enter Account Holder"
                            maxLength={100}
                            style={borderStyle("accountHolder")}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Bank Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="bankName"
                            className="form-control"
                            value={formData.bankName}
                            onChange={handleChange}
                            placeholder="Enter Bank Name "
                            maxLength={100}
                            style={borderStyle("bankName")}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <div
                            className="d-flex align-items-center justify-content-start"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            <label
                              className="mb-1"
                              style={{ fontWeight: 500, fontSize: "14px" }}
                            >
                              Wire Routing Number{" "}
                              <span className="text-muted">
                                (Wire transfers only, no ACH)
                              </span>{" "}
                              <span className="text-danger">*</span>
                            </label>
                            {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
                                    
                                    <span>
                                      <IoMdInformationCircleOutline
                                        fontSize={"16px"}
                                        className="ms-1 mb-1"
                                      />
                                    </span>
                                  </Tooltip> */}
                          </div>
                          <input
                            // readOnly={issubmitting}
                            name="routingNumber"
                            type="number"
                            className="form-control"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.routingNumber}
                            onBlur={(e) =>
                              validateRoutingNumber(e.target.value)
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value.length <= 9) {
                                handleChange(e);
                              }
                            }}
                            min={0}
                            max={999999999}
                            placeholder="Enter Routing Number"
                            style={borderStyle("routingNumber")}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <label
                            // className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Account Number{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="accountNumber"
                            className="form-control"
                            min={0}
                            max={99999999999999999}
                            placeholder="Enter  Account Number "
                            type="number"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.accountNumber}
                            onBlur={(e) =>
                              validateAccountNumber(e.target.value)
                            }
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow empty string for deletion
                              if (value === "" || value.length <= 17) {
                                handleChange(e);
                              }
                            }}
                            style={borderStyle("accountNumber")}
                          />
                        </div>
                        {routingNumError && (
                          <div
                            className={
                              accountNumError && routingNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {routingNumError}
                            </span>
                          </div>
                        )}
                        {accountNumError && (
                          <div
                            className={
                              accountNumError && routingNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {accountNumError}
                            </span>
                          </div>
                        )}

                        {/* Documents for Contractor */}
                        {/* <div className="row"> */}

                        {/* </div> */}
                      </div>
                    </>
                  )}
                </>
              )}
            </Box>
          </div>
          <div
            style={{
              position: "sticky",
              bottom: 0,
              background: "#fff",
              borderTop: "1px solid #ddd",
              padding: "16px 24px",
              textAlign: "right",
            }}
          >
            <button
              className="btn btn-cvault ms-auto mt-3 d-flex align-items-center justify-content-center"
              style={{ width: "25%" }}
              onClick={handleSubmit}
              disabled={issubmitting}
            >
              {issubmitting ? (
                <>
                  <span className="me-2">Creating user...</span>
                  <CircularProgress size={18} color="inherit" />
                </>
              ) : (
                "Create User"
              )}
            </button>
          </div>
        </form>
      </Drawer>

      <Modal
        open={viewReport}
        onClose={() => {
          setShowDocuments(null);
          setFileError("");
          setViewReport(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, top: "50%", height: "85%" }}>
          <div className="h-100">
            {showDocuments && (
              <div
                style={{
                  padding: "0px 10px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <label className="" style={{ fontSize: "14px" }}>
                    {modalTitle} :{" "}
                    <span className="text-primary">
                      {showDocuments.file_name}
                    </span>
                  </label>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowDocuments(null);
                      setFileError("");
                      setViewReport(false);
                    }}
                  >
                    <IoMdClose fontSize={"20px"} />
                  </span>
                </div>

                {/* Image preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <img
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "75vh",
                      }}
                      src={showDocuments.base64_content}
                      alt="Document preview"
                    />
                  )}

                {/* PDF preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(pdf)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}

                {/* Video preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <video
                      style={{ width: "100%", height: "75vh" }}
                      controls
                      src={showDocuments.base64_content}
                    ></video>
                  )}

                {/* Text preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(txt)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}
              </div>
            )}

            {fileError !== "" && (
              <div className="text-danger text-center">{fileError}</div>
            )}
          </div>
        </Box>
      </Modal>
      {isLoader && (
        <div className="loader-overlay">
          <span className="loader-message">
            Fetching document from cloud storage. Please wait...
          </span>

          <BarLoader
            color="#F5AE41"
            width={"80%"}
            height={5}
            className="loader"
            loading={isLoader}
          />
        </div>
      )}

      <Modal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false);
          setPreviewModaTitle("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            // maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>{previewModaTitle}</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setPreviewModal(false);
                  setPreviewModaTitle("");
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default AddUser;
